import type { ProductLogoSmallProps } from "../types";

/**
 * 小サイズのTimeAndAttendanceロゴアイコン
 */
export function ProductLogoSmallTimeAndAttendance({
  size = 20,
  color = "#0070C0",
  ...props
}: ProductLogoSmallProps): JSX.Element {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 21 20"
      fill="none"
      {...props}
    >
      <path
        d="M3.87653 14.1682C3.69016 13.8873 3.52202 13.5927 3.37378 13.286C3.22554 12.9794 3.09913 12.6647 2.99474 12.3441C2.86648 11.9503 2.44323 11.7349 2.04937 11.8632C1.65552 11.9915 1.44021 12.4147 1.56847 12.8086C1.69375 13.1933 1.84544 13.571 2.0233 13.9389C2.20116 14.3068 2.40293 14.6603 2.6266 14.9974C2.8556 15.3426 3.32104 15.4368 3.6662 15.2078C4.01136 14.9788 4.10553 14.5133 3.87653 14.1682Z"
        fill={color}
      />
      <path
        d="M6.31257 16.4799C5.9559 16.2693 5.49602 16.3877 5.2854 16.7443C5.07479 17.101 5.19319 17.5609 5.54986 17.7715C5.89824 17.9772 6.26181 18.1602 6.63853 18.3186C7.01525 18.4769 7.40036 18.6087 7.7911 18.7136C8.19113 18.8211 8.60254 18.5839 8.71001 18.1839C8.81748 17.7839 8.58031 17.3725 8.18029 17.265C7.8547 17.1775 7.53378 17.0678 7.2198 16.9358C6.90582 16.8038 6.60286 16.6513 6.31257 16.4799Z"
        fill={color}
      />
      <path
        d="M1.21022 8.79454C1.15374 9.20488 1.44059 9.58332 1.85094 9.63981C2.26128 9.69629 2.63972 9.40943 2.69621 8.99909C2.74218 8.66511 2.81086 8.33296 2.90245 8.00492C2.99404 7.67687 3.10736 7.35718 3.24105 7.0477C3.4053 6.66744 3.2302 6.22603 2.84994 6.06178C2.46969 5.89753 2.02828 6.07263 1.86402 6.45288C1.70359 6.82431 1.5676 7.20794 1.45771 7.60154C1.34781 7.99514 1.2654 8.39372 1.21022 8.79454Z"
        fill={color}
      />
      <path
        d="M11.5363 17.3881C11.1295 17.4659 10.8629 17.8589 10.9407 18.2657C11.0186 18.6725 11.4116 18.9392 11.8184 18.8613C12.2158 18.7852 12.6095 18.6821 12.9968 18.5517C13.3841 18.4214 13.7601 18.2655 14.1226 18.0859C14.4938 17.9019 14.6455 17.452 14.4616 17.0808C14.2777 16.7097 13.8277 16.5579 13.4565 16.7418C13.1545 16.8915 12.8412 17.0214 12.5184 17.1301C12.1956 17.2387 11.8675 17.3247 11.5363 17.3881Z"
        fill={color}
      />
      <path
        d="M15.3538 11.5546L15.3538 15.1665C15.3538 15.3506 15.5031 15.4998 15.6871 15.4998L19.2991 15.4998C19.596 15.4998 19.7448 15.1408 19.5348 14.9308L15.9229 11.3189C15.7129 11.1089 15.3538 11.2576 15.3538 11.5546Z"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.312 1.02151C12.4059 1.06537 14.4189 1.8381 16.0043 3.20658C17.5897 4.57506 18.6482 6.45361 18.9975 8.51861C19.3467 10.5836 18.9649 12.7058 17.9177 14.5195C17.7106 14.8783 17.2519 15.0012 16.8932 14.7941C16.5345 14.5869 16.4116 14.1283 16.6187 13.7695C17.4913 12.2581 17.8095 10.4896 17.5185 8.76877C17.2274 7.04793 16.3453 5.48247 15.0242 4.34207C13.703 3.20167 12.0255 2.55773 10.2806 2.52118C8.53569 2.48463 6.83267 3.05776 5.46491 4.14183C5.14029 4.39912 4.66856 4.34454 4.41128 4.01992C4.15399 3.69531 4.20857 3.22358 4.53318 2.96629C6.1745 1.6654 8.21812 0.977646 10.312 1.02151Z"
        fill={color}
      />
      <path
        d="M9.60427 4.49988C9.32813 4.49988 9.10427 4.72374 9.10427 4.99988V10.2082C9.10427 10.3647 9.17615 10.5044 9.28869 10.5961L12.0503 13.3576C12.2455 13.5529 12.5621 13.5529 12.7574 13.3576L13.4645 12.6505C13.6597 12.4553 13.6597 12.1387 13.4645 11.9434L11.1043 9.58321V4.99988C11.1043 4.72374 10.8804 4.49988 10.6043 4.49988H9.60427Z"
        fill={color}
      />
    </svg>
  );
}
